import { render, staticRenderFns } from "./myWalletRechange.vue?vue&type=template&id=74160604&scoped=true"
import script from "./myWalletRechange.vue?vue&type=script&lang=js"
export * from "./myWalletRechange.vue?vue&type=script&lang=js"
import style0 from "./myWalletRechange.vue?vue&type=style&index=0&id=74160604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74160604",
  null
  
)

export default component.exports